/* eslint-disable react/jsx-props-no-spreading */

import {
    Container, Grid,
} from '@mui/material'

import DashboardWidget from 'app/common/Dashboard/components/DashboardWidget'
import useAllowedLinks from 'app/MainMenu/hooks/useAllowedLinks'
import {
    ActiveTab,
} from 'app/MainMenu/MainMenu.types'

import useStyles from './Dashboard.style'

export default function Dashboard({
    customLinks,
}: Readonly<{
    customLinks?: ActiveTab[]
}>) {
    const {
        classes,
    } = useStyles()
    const allowedLinks = useAllowedLinks()

    return (
        <Container
            data-testid="dashboard"
            className={classes.containerWrapper}
            maxWidth="xl"
        >
            <Grid
                container
                spacing={6}
                className={classes.container}
            >
                {
                    (customLinks || allowedLinks).map((widget) => {
                        return (
                            <DashboardWidget
                                data-testid={`dashboard-widget-${widget.id}`}
                                key={widget.id}
                                {...widget}
                            />
                        )
                    })
                }
            </Grid>
        </Container>
    )
}
